// extracted by mini-css-extract-plugin
export default {"session-dialog":"existing-session-dialog_session-dialog__MBcCn","container":"existing-session-dialog_container__c2kia"};